<template>
  <div>
    <SubSideMenu
      :subsection="'Configuration'"
      :options="options"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import SubSideMenu from "@/components/SideMenu/SubSideMenu/SubSideMenu.vue"

export default {
  name: "ConfigurationSidebar",
  components: {
    SubSideMenu
  },
  computed: {
    ...mapGetters(["configurationNav"]),
    options() {
      return this.configurationNav
    }
  }
}
</script>